import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const tree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Prerendered pages ship real HTML in #root — hydrate it instead of re-rendering from scratch.
// If the shell was served as a fallback for another route, drop the stale markup first.
const pre = window.__PRERENDER_DATA__;
const norm = (p) => p.replace(/\/+$/, '') || '/';
if (container.hasChildNodes() && pre && norm(pre.route) === norm(window.location.pathname)) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  container.innerHTML = '';
  ReactDOM.createRoot(container).render(tree);
}
